import { Component, Element, Prop, h, EventEmitter, Event, Method } from '@stencil/core';
import { Color } from '../../../interface';
import { createModal } from '../modal/modal-controller';
import { InputResponse } from './node-interface';

@Component({
  tag: 'lar-node-more-buttons',
  styleUrl: 'node.scss',
  shadow: true
})

export class NodeMoreButtons {
  private logmodal?: HTMLLarModalElement;

  @Element() el!: HTMLElement;
  @Prop() colorInputs?: Color;
  @Prop() colorModal?: Color;
  @Prop() log: boolean = false;
  /**
   * Larva sub-components request event
   */
  @Event() request!: EventEmitter;

  /**
   * Request response method
   */
  @Method()
   async response(data: InputResponse) {
    switch(data.topic) {
      case 'iot-2/evt/getNodeLogs/fmt/json':
        if (this.logmodal) {
          ((await this.logmodal.getComponent()).element as HTMLLarLogModalElement)
            .response(data.payload?.data);
        }
        break;
    }
   }

  async openLogModal() {
    this.logmodal = await createModal({
      mainTitle: 'log.log',
      color: this.colorModal || this.colorInputs,
      animation: 'bottom',
      iconSmall: 'loading',
      colorHeaderInputs: this.colorInputs,
      icon: 'log',
      headerSize:'small',
      component: 'lar-log-modal',
      componentProps: {
        onRequest: (event: CustomEvent) => this.request.emit({
          topic: 'iot-2/cmd/getNodeLogs/fmt/json',
          payload: {
            // reqId ?
            data: event.detail
          }
        }), // pass request event
      }
    });
    await this.logmodal.present();
  }

  public async disconnectedCallback() {
    return this.logmodal?.dismiss();
  }

  render() {
    return (
    <div>
      <div class="spacer" />
      {(this.log || this.log)
        &&
        <div><lar-list-header><lar-translate t="node.more" /></lar-list-header><div class="spacer" /></div>
      }
      <lar-button-group>
        {this.log &&
          <lar-button
            color={(this.colorInputs) === 'dark' ? 'light' : 'dark'}
            expand="full"
            onClick={() => this.openLogModal()}
          >
            <lar-translate t="log.log" />
          </lar-button>
        }
      </lar-button-group>
    </div>
    );
  }
}